export default [
    {
        path: 'newsletter-import-jobs',
        name: 'system-logs-newsletter-import',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: 'modules.newsletter',
            translate: (t) => {
                return t('menu_points.system_newsletter_import_jobs').ucFirst();
            },
        },
        component: () => import('@/views/pages/newsletters/source-jobs/list.vue')
    },
];